/**
 * Канон copy: docs/product/2026-08-16-sections-naming-glossary.md (P0).
 * Не меняет домен — только тексты UI.
 */

export const SECTIONS_LIST_HINT =
  'Секция — направление занятий, которое клиент видит в каталоге приложения.';

export const SECTIONS_GROUPS_HINT =
  'Добавьте группу и укажите, в какие дни и во сколько проходят занятия. ' +
  'После сохранения эти занятия появятся в расписании зала, и клиенты смогут записаться на них в приложении.';

export const SECTIONS_ABONEMENT_HINT =
  'Абонемент даёт клиенту доступ к выбранным секциям. Это не аренда зала и не прокат снаряжения.';

export const TIMETABLE_CLIENT_HINT =
  'Здесь видно, чем занят зал: занятия секций, аренда и блокировки. ' +
  'В приложении аренда и секции — разные разделы.';
